'use strict'

module.exports = require('web-encoding').TextDecoder
